function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", null, "create-letter");

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.49,
    height: 20.01,
    viewBox: "0 0 20.49 20.01"
  }, props), _ref, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "9.16 12.82 6.56 13.07 7.04 10.51 16.06 2.11 18.18 4.42 9.16 12.82",
    style: {
      "fill": "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.32,1.55,19.09.21a.67.67,0,0,0-.93,0l-.08.07L17.47.8,17,1.25l.44.48,1.23,1.34.45.49.48-.45.61-.56.08-.07A.67.67,0,0,0,20.32,1.55Z",
    style: {
      "fill": "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.6,9.33V18a.42.42,0,0,1-.41.41H2A.42.42,0,0,1,1.58,18V5.82A.42.42,0,0,1,2,5.41h8.67l1.7-1.58H2a2,2,0,0,0-2,2V18a2,2,0,0,0,2,2H14.19a2,2,0,0,0,2-2V7.86Z",
    style: {
      "fill": "#fff"
    }
  })));
};

export default __webpack_public_path__ + "static/media/create-letter.105336af.svg";
export { SvgComponent as ReactComponent };